import {ApolloLink} from '@apollo/client';
import type {DataConfig} from '@sail/data';
import anonymousTypes from '../../schema/anonymousTypes.json';
import fieldVersionOverrides from '../../schema/fieldVersionOverrides.json';
import pbeMap from '../../schema/pbe';
import unionObjectTypesMap from '../../schema/unionObjectTypesMap.json';
import getPossibleTypes from '../shared/graphql/utils/getPossibleTypes';
import createV1ApolloLink from './createV1ApolloLink';
import topLevelFieldsInputTypes from '../../schema/topLevelFieldsInputTypes';
import type {ComparisonLinkOptions} from './links/createComparisonV1ToV2Link';

export default function getV1SchemaConfig(
  apolloLinks: ApolloLink[],
  comparisonLinkOptions?: ComparisonLinkOptions,
): NonNullable<DataConfig['graphql']>['schemas'] {
  return {
    gql: {
      apolloLink: ApolloLink.from([
        ...apolloLinks,
        createV1ApolloLink(
          unionObjectTypesMap,
          pbeMap,
          topLevelFieldsInputTypes,
          fieldVersionOverrides,
          comparisonLinkOptions,
        ),
      ]),
      possibleTypes: getPossibleTypes(unionObjectTypesMap),
      anonymousTypes,
    },
  };
}
